import React, { useState, useEffect } from 'react'
import { withStyles } from '@material-ui/core'
import { CoreTextField } from 'src/components/core'
import { Box, Typography } from '@material-ui/core'
import { useSelector } from 'react-redux'
import UpgradePopover from 'src/components/upgrade-popover/upgrade-popover'
import styles from './styles'

const AdvancedSettings = props => {
  const { classes, onSave, initialSettings } = props
  const isUserPremium = Number(window.CONSTANTS.USER_ROLE_ID) !== 1
  const pageUrl = window.location.pathname.split('/')[1]
  const courseSettings = useSelector(state => state.course.landingPageSettings)
  const collectionSettings = useSelector(
    state => state.collection.landingPageSettings,
  )

  const landingPageData =
    pageUrl === 'mini-course' ? courseSettings || {} : collectionSettings || {}

  const [headerScript, setHeaderScript] = useState('')
  const [bodyScript, setBodyScript] = useState('')
  const [anchorEl, setAnchorEl] = useState(null)

  // Initialize state from props when available
  useEffect(() => {
    if (landingPageData) {
      setHeaderScript(landingPageData.headerScripts || '')
      setBodyScript(landingPageData.bodyScripts || '')
    }
  }, [landingPageData])

  const open = Boolean(anchorEl)
  const popupHeader = 'Upgrade to Pro'
  const popupContent =
    'Upgrade to Pro Plans account to access privileged features.'

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <div className={classes.container}>
      <div className={classes.scriptSection}>
        <Typography
          fontSize="16px"
          fontWeight={400}
          fontFamily="Inter"
          className={classes.header}
        >
          Advanced settings
        </Typography>
        <div>
          <Typography fontSize="14px" fontWeight={400} fontFamily="Inter">
            Header and Body Scripts
          </Typography>
          <Typography fontSize="12px" fontWeight={400} color="#919EAB">
            Add custom CSS & JS codes, like Google Analytics tracking code,
            Facebook Pixel, etc.
          </Typography>
        </div>

        <Box>
          <div className={classes.badgeHeader}>
            <Typography fontSize={'14px'} fontWeight={400}>
              Header Script
            </Typography>
            {!isUserPremium && (
              <div className={classes.badge}>
                <Typography
                  fontSize={'11px'}
                  fontWeight={500}
                  style={{ color: '#015FFB' }}
                >
                  Pro
                </Typography>
              </div>
            )}
          </div>

          <CoreTextField
            multiline
            rows={5}
            fullWidth
            placeholder="The codes you are going to write to this field will be added before </head> tag. You can add custom CSS or JS codes to this field."
            value={headerScript}
            marginTop={false}
            // CHANGE THIS onChange handler
            onChange={e => {
              const newValue = e.target.value
              setHeaderScript(newValue)
              if (initialSettings) {
                onSave({
                  ...initialSettings, // This preserves all other settings
                  headerScript: newValue,
                })
              }
            }}
            disabled={!isUserPremium}
          />
        </Box>

        <Box>
          <div className={classes.badgeHeader}>
            <Typography fontSize={'14px'} fontWeight={400}>
              Body Script
            </Typography>
            {!isUserPremium && (
              <div className={classes.badge}>
                <Typography
                  fontSize={'11px'}
                  fontWeight={500}
                  style={{ color: '#015FFB' }}
                >
                  Pro
                </Typography>
              </div>
            )}
          </div>

          <CoreTextField
            multiline
            rows={5}
            fullWidth
            marginTop={false}
            placeholder="The codes you are going to write to this field will be added before </body> tag."
            variant="outlined"
            value={bodyScript}
            // CHANGE THIS onChange handler
            onChange={e => {
              const newValue = e.target.value
              setBodyScript(newValue)
              if (initialSettings) {
                onSave({
                  ...initialSettings, // This preserves all other settings
                  bodyScript: newValue,
                })
              }
            }}
            disabled={!isUserPremium}
          />
        </Box>
      </div>

      <UpgradePopover
        id={open ? 'upgrade-popover' : undefined}
        anchorEl={anchorEl}
        handleClose={handleClose}
        open={open}
        header={popupHeader}
        content={popupContent}
      />
    </div>
  )
}
export default withStyles(styles)(AdvancedSettings)
